import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";

interface EditExpertProps {}

interface ExpertFormData {
  expertName: string;
  academicRank: string;
  academicDegree: string;
  specialization: string;
  phone: string;
  email: string;
  workplace: string;
  notes: string;
}

const EditExpert: React.FC<EditExpertProps> = () => {
  const navigate = useNavigate();

  const getExpertId = () => {
    const parts = window.location.pathname.split("/");
    return parts[parts.length - 1];
  };
  const id = getExpertId();

  const [formData, setFormData] = useState<ExpertFormData>({
    expertName: "",
    academicRank: "",
    academicDegree: "",
    specialization: "",
    phone: "",
    email: "",
    workplace: "",
    notes: "",
  });

  const mockExpertData: ExpertFormData = {
    expertName: "Thượng tá, VS. ThS Lê Anh Tuấn",
    academicRank: "Viên sĩ",
    academicDegree: "Thạc sĩ",
    specialization: "Tài nguyên nước và bảo vệ môi trường",
    phone: "0988662866",
    email: "tuan@rnet.vn",
    workplace: "Phòng Vật liệu/Viện Độ bền nhiệt đới",
    notes: "Chuyên gia đầu ngành",
  };

  useEffect(() => {
    if (id) {
      setFormData(mockExpertData);
    }
  }, [id]);

  const handleInputChange = (field: keyof ExpertFormData, value: string) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancel = () => {
    window.history.back();
  };

  const handleSave = () => {
    console.log("Updating expert:", formData);
    navigate("/experts");
  };

  return (
    <PageShell title="Sửa Chuyên gia">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Sửa Chuyên gia
          </h1>
        </div>

        <div className="bg-white rounded-lg p-6">
          <div className="space-y-8">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Họ tên chuyên gia <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="text"
                  value={formData.expertName}
                  onChange={(e) =>
                    handleInputChange("expertName", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập tên chuyên gia..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Học hàm
                </label>
                <select
                  value={formData.academicRank}
                  onChange={(e) =>
                    handleInputChange("academicRank", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option>- Học hàm -</option>
                  <option>Giáo sư</option>
                  <option>Phó Giáo sư</option>
                  <option>Viên sĩ</option>
                  <option>Phó Viện sĩ</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Học vị
                </label>
                <select
                  value={formData.academicDegree}
                  onChange={(e) =>
                    handleInputChange("academicDegree", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option>- Học vị -</option>
                  <option>Tiến sĩ</option>
                  <option>Tiến sĩ KH</option>
                  <option>Thạc sĩ</option>
                  <option>Kỹ sư</option>
                  <option>Cử nhân</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Lĩnh vực nghiên cứu
                </label>
                <select
                  value={formData.specialization}
                  onChange={(e) =>
                    handleInputChange("specialization", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option>- Chọn lĩnh vực nghiên cứu -</option>
                  <option>Công nghệ thông tin và tự động hóa</option>
                  <option>Tài nguyên nước và bảo vệ môi trường</option>
                  <option>Khoa học tự nhiên</option>
                  <option>Khoa học xã hội</option>
                  <option>Y học</option>
                  <option>Nông nghiệp</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Điện thoại <span className="text-red-500">(*)</span>
                </label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => handleInputChange("phone", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Điện thoại"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange("email", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Email"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Đơn vị công tác
                </label>
                <input
                  type="text"
                  value={formData.workplace}
                  onChange={(e) =>
                    handleInputChange("workplace", e.target.value)
                  }
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Nhập đơn vị công tác..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Ghi chú
                </label>
                <input
                  type="text"
                  value={formData.notes}
                  onChange={(e) => handleInputChange("notes", e.target.value)}
                  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Ghi chú"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2">
          <button
            onClick={handleCancel}
            className="bg-gray-300 text-gray-700 px-6 py-2 rounded-md text-sm font-medium hover:bg-gray-400 transition-colors flex items-center space-x-2"
          >
            <span>Hủy</span>
          </button>
          <button
            onClick={handleSave}
            className="bg-green-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-green-700 transition-colors flex items-center space-x-2"
          >
            <span>Lưu dữ liệu</span>
          </button>
        </div>
      </div>
    </PageShell>
  );
};

export default EditExpert;
